var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import { defineComponent, reactive, toRefs, ref, computed, isRef, unref, nextTick, watch, onBeforeUpdate, onMounted, openBlock, createElementBlock, Fragment, renderList, withDirectives, createElementVNode, mergeProps, toHandlers, vModelDynamic } from "vue";
var SplitInput_vue_vue_type_style_index_0_scoped_true_lang = "";
var _export_sfc = (sfc, props) => {
  const target = sfc.__vccOpts || sfc;
  for (const [key, val] of props) {
    target[key] = val;
  }
  return target;
};
const _sfc_main = defineComponent({
  inheritAttrs: false,
  props: {
    modelValue: String,
    inputNumber: {
      type: Number,
      default: 6
    },
    maxLength: {
      type: Number,
      default: 1
    },
    type: {
      type: String,
      default: "tel"
    },
    className: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: ""
    },
    placeholders: {
      type: Array,
      default: null
    }
  },
  emits: ["update:modelValue", "focus"],
  setup: (props, { emit, attrs }) => {
    const data = reactive({
      index: null,
      values: []
    });
    const { inputNumber, modelValue, placeholders, placeholder } = toRefs(props);
    const input = ref([]);
    const firstInput = computed(() => {
      var _a;
      return (_a = input.value) == null ? void 0 : _a[0];
    });
    const lastInput = computed(() => {
      var _a;
      return (_a = input.value) == null ? void 0 : _a[inputNumber.value - 1];
    });
    const joinedValues = computed(() => data.values.join(""));
    const nextInput = computed(() => {
      var _a;
      return (_a = input.value) == null ? void 0 : _a[data.index + 1];
    });
    const currentInput = computed(() => {
      var _a;
      return (_a = input.value) == null ? void 0 : _a[data.index];
    });
    const previousInput = computed(() => {
      var _a;
      return (_a = input.value) == null ? void 0 : _a[data.index - 1];
    });
    const currentPlaceholder = computed(() => {
      var _a;
      return isRef(placeholders) && ((_a = unref(placeholders)) == null ? void 0 : _a[data.index]) || unref(placeholder);
    });
    const computedListeners = __spreadProps(__spreadValues({}, attrs), {
      blur: () => data.index = null,
      change: () => emit("update:modelValue", joinedValues.value),
      focus: (event) => {
        data.index = [...input.value].indexOf(event.target);
        nextTick(() => emit("focus", event));
      },
      input: (event) => {
        if (event.inputType === "insertText") {
          navigate(nextInput.value);
        }
        emit("update:modelValue", joinedValues.value);
      },
      keydown: (event) => {
        const cursorPosition = Number(event.target.dataset.index);
        const currentValue = data.values[cursorPosition];
        switch ((event == null ? void 0 : event.code) || (event == null ? void 0 : event.key) || (event == null ? void 0 : event.which) || (event == null ? void 0 : event.keyCode)) {
          case "ArrowDown":
          case 40:
            navigate(lastInput.value);
            break;
          case "ArrowLeft":
          case 37:
            if (cursorPosition === 0 || !currentValue) {
              navigate(previousInput.value);
            }
            break;
          case "ArrowRight":
          case 39:
            if (cursorPosition === 1 || !currentValue) {
              navigate(nextInput.value);
            }
            break;
          case "ArrowUp":
          case 38:
            navigate(firstInput.value);
            break;
          case "Backspace":
          case 8:
            if (cursorPosition !== 0) {
              data.values[cursorPosition] = "";
            }
            nextTick(() => navigate(previousInput.value));
            break;
        }
      },
      paste: (event) => {
        event.preventDefault();
        const pasteValues = event.clipboardData.getData("text/plain").split("").slice(0, inputNumber.value);
        data.values = pasteValues;
        navigate(input.value[pasteValues.length < inputNumber.value ? pasteValues.length - 1 : inputNumber.value]);
        emit("update:modelValue", joinedValues.value);
      }
    });
    watch(() => modelValue, (value) => {
      if (value !== joinedValues.value) {
        mapModelData();
      }
    });
    onBeforeUpdate(() => input.value = []);
    onMounted(() => mapModelData());
    const mapModelData = () => {
      var _a;
      return data.values = (_a = modelValue == null ? void 0 : modelValue.value) == null ? void 0 : _a.toString().split("");
    };
    const navigate = (input2) => {
      if (input2) {
        input2.focus();
        input2.select();
      }
    };
    const clearAllInput = () => {
      data.values = [];
      nextTick(() => emit("update:modelValue", joinedValues.value));
    };
    return __spreadProps(__spreadValues({}, toRefs(data)), {
      input,
      computedListeners,
      currentPlaceholder,
      currentInput,
      clearAllInput
    });
  }
});
const _hoisted_1 = ["type", "disabled", "maxlength", "placeholder", "onUpdate:modelValue", "data-index"];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.inputNumber, (i) => {
    return openBlock(), createElementBlock("div", {
      class: "`grid grid-cols-${maxLength} gap-4`",
      key: i
    }, [
      withDirectives(createElementVNode("input", mergeProps({
        ref_for: true,
        ref: (el) => {
          if (el)
            _ctx.input[i] = el;
        },
        type: _ctx.type,
        class: _ctx.className
      }, toHandlers(_ctx.computedListeners), {
        disabled: _ctx.disabled,
        maxlength: _ctx.maxLength,
        placeholder: _ctx.currentPlaceholder,
        "onUpdate:modelValue": ($event) => _ctx.values[i - 1] = $event,
        "data-index": `${i - 1}`
      }), null, 16, _hoisted_1), [
        [vModelDynamic, _ctx.values[i - 1]]
      ])
    ]);
  }), 128);
}
var VueSplitInput = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__scopeId", "data-v-159111bf"]]);
const SplitInput = {
  install: (app, options = {}) => {
    app.component("split-input", VueSplitInput);
  }
};
export { SplitInput as default };
